import React, { useState, useRef } from "react";
import "./D_one.css";
import download_img from "../../assets/images/download_img.png";
import emailjs from '@emailjs/browser';

const copyFilePath = "http://localhost:3000/Investment-Suburb-Report.pdf";

function D_one() {
  const [formData, setFormData] = useState({
    user_name: "",  // ✅ Updated keys to match EmailJS template
    user_email: "",
    user_phone: "",
    user_postcode: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const form = useRef();

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleDownloadAndSendEmail = async (event) => {
    event.preventDefault();
    const { user_name, user_email, user_phone, user_postcode } = formData;

    if (!user_name || !user_email || !user_phone || !user_postcode) {
      alert("Please fill in all fields before proceeding.");
      return;
    }

    console.log("Form Data Before Sending:", formData);  // ✅ Debugging

    setIsSubmitting(true);
    
    try {
      const response = await emailjs.sendForm(
        "service_q6o7bgg",
        "template_hbbz9f4",
        form.current,
        "2-25cknvcGJMTzW9I"
      );

      console.log("EmailJS Response:", response);  // ✅ Check response
      alert("Email sent successfully!");
      
      const link = document.createElement("a");
      link.href = copyFilePath;
      link.download = "Investment-Suburb-Report.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      alert("File downloaded successfully!");
      
      setFormData({ user_name: "", user_email: "", user_phone: "", user_postcode: "" });
      form.current.reset();
    } catch (error) {
      console.error("Error sending email:", error);  // ✅ Log error
      alert("Error sending email: " + error.text);
    }

    setIsSubmitting(false);
  };

  return (
    <div className="d-one">
      <p>Brand new 2025 Australia property investor edition</p>
      <h2 className="underline">Melbourne's Underdog Investment</h2>
      <h2>
        <span className="underline">Suburbs 2025</span>
      </h2>
      <p>
        <b>Download our FREE Guide:</b> “Melbourne’s Underdog Suburbs: Hidden Investment Gems for 2025”
      </p>

      <div className="download-section">
        <img className="download-img" src={download_img} alt="Download" />
        <div className="download-form container">
          <div className="row">
            <div id="content">
              <form ref={form} onSubmit={handleDownloadAndSendEmail}>
                <input
                  type="text"
                  className="form-control"
                  id="name" 
                  name="user_name"  // ✅ Updated name attributes
                  required placeholder="Enter Your Full Name"
                  onChange={handleChange}
                  value={formData.user_name}
                />
                <input
                  type="email"
                  className="form-control"
                  id="email" 
                  name="user_email"  // ✅ Matches EmailJS template
                  required placeholder="Enter Your Email"
                  onChange={handleChange}
                  value={formData.user_email}
                />

                <input 
                  type="number"
                  className="form-control" 
                  id="phone" 
                  name="user_phone"  // ✅ Matches EmailJS template
                  required placeholder="Enter Phone Number" 
                  onChange={handleChange} 
                  value={formData.user_phone} 
                />
                
                  {/* <input
                    type="number"
                    placeholder="Enter Phone Number"
                    name="phone"
                    {...register("phone", {
                      required: "Phone number is required",
                      validate: validateAustralianPhoneNumber,
                    })}
                    className="form-control"
                  /> */}
                <input 
                  type="number" 
                  className="form-control" 
                  id="postcode" 
                  name="user_postcode"  // ✅ Matches EmailJS template
                  required placeholder="Enter Post Code" 
                  onChange={handleChange} 
                  value={formData.user_postcode} 
                />
                <button id="submit" type="submit" disabled={isSubmitting}>
                  {isSubmitting ? "Processing..." : "★ FREE DOWNLOAD"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default D_one;
